import loadable from '@loadable/component';

// Routes
import coreTicketportalRoutes from '../../core-ticketportal/routes';

export default {
	home: coreTicketportalRoutes.home,
	login: coreTicketportalRoutes.login,
	eventDetail: coreTicketportalRoutes.eventDetail,
	customForm: coreTicketportalRoutes.customForm,
	payment: coreTicketportalRoutes.payment,
	checkout: coreTicketportalRoutes.checkout,
	checkoutSummary: coreTicketportalRoutes.checkoutSummary,
	faq: coreTicketportalRoutes.faq,
	page: coreTicketportalRoutes.page,
	contact: coreTicketportalRoutes.contact,
	events: coreTicketportalRoutes.events,
	eventsWithLocation: coreTicketportalRoutes.eventsWithLocation,
	search: coreTicketportalRoutes.search,
	menu: coreTicketportalRoutes.menu,
	walletInstructions: coreTicketportalRoutes.walletInstructions,
	superMuzikFest: {
		path: '/super-muzik-fest',
		redirect: {
			key: 'superMuzikFest.about',
			params: {},
		},
		head: {
			title: 'Süper Müzik Fest',
		},
		children: {
			about: {
				path: '/super-muzik-fest/hakkinda',
				exact: true,
				layout: 'guide',
				layoutClass: 'smf-info',
				layoutProps: {
					title: 'Süper Müzik Fest Hakkında',
				},
				head: {
					title: 'Süper Müzik Fest Hakkında',
				},
				component: loadable(() => import('/views/pages/smf/about')),
				menuIcon: 'info',
			},
			map: {
				path: '/super-muzik-fest/alan-krokisi',
				exact: true,
				layout: 'guide',
				layoutClass: 'smf-map',
				layoutProps: {
					title: 'Super Müzik Fest Alan Krokisi',
				},
				head: {
					title: 'Super Müzik Fest Alan Krokisi',
				},
				component: loadable(() => import('/views/pages/smf/map')),
				menuIcon: 'map',
			},
			lineUp: {
				path: '/super-muzik-fest/line-up',
				exact: true,
				layout: 'guide',
				layoutClass: 'smf-lineup',
				layoutProps: {
					title: 'Super Müzik Fest Line Up',
				},
				head: {
					title: 'Super Müzik Fest Line Up',
				},
				component: loadable(() => import('/views/pages/smf/line-up')),
				menuIcon: 'mic',
			},
			ifPayUsage: {
				path: '/super-muzik-fest/if-pay-nasil-kullanilir',
				exact: true,
				layout: 'guide',
				layoutClass: 'smf-if-pay-usage',
				layoutProps: {
					title: 'IF Pay Nasıl Kullanılır?',
				},
				head: {
					title: 'IF Pay Nasıl Kullanılır?',
				},
				component: loadable(() => import('/views/pages/smf/if-pay-usage')),
				menuIcon: 'wallet',
			},
			faq: {
				path: '/super-muzik-fest/sss',
				exact: true,
				layout: 'guide',
				layoutClass: 'smf-faq',
				layoutProps: {
					title: 'Sıkça Sorulan Sorular',
				},
				head: {
					title: 'Sıkça Sorulan Sorular',
				},
				component: loadable(() => import('/views/pages/smf/faq')),
				menuIcon: 'help',
			},
			menu: {
				path: '/super-muzik-fest/yiyecek-icecek-menu',
				exact: true,
				layout: 'guide',
				layoutClass: 'smf-menu',
				layoutProps: {
					title: 'Yiyecek İçecek Menüsü',
				},
				head: {
					title: 'Yiyecek İçecek Menüsü',
				},
				component: loadable(() => import('/views/pages/smf/menu')),
				menuIcon: 'qr',
			},
		},
	},
	mabelMatiz: {
		path: '/mabel-matiz',
		redirect: {
			key: 'mabelMatiz.about',
			params: {},
		},
		head: {
			title: 'Süper Müzik Fest',
		},
		children: {
			about: {
				path: '/mabel-matiz/hakkinda',
				exact: true,
				layout: 'guide',
				layoutClass: 'mabel-matiz-info',
				layoutProps: {
					title: 'Etkinlik Hakkında',
				},
				head: {
					title: 'Mabel Matiz Etkinliği Hakkında',
				},
				component: loadable(() => import('/views/pages/mabel-matiz/about')),
				menuIcon: 'info',
			},
			lineUp: {
				path: '/mabel-matiz/line-up',
				exact: true,
				layout: 'guide',
				layoutClass: 'mabel-matiz-lineup',
				layoutProps: {
					title: 'Line Up',
				},
				head: {
					title: 'Mabel Matiz Etkinliği Line Up',
				},
				component: loadable(() => import('/views/pages/mabel-matiz/line-up')),
				menuIcon: 'mic',
			},
			ifPayUsage: {
				path: '/mabel-matiz/if-pay-nasil-kullanilir',
				exact: true,
				layout: 'guide',
				layoutClass: 'mabel-matiz-if-pay-usage',
				layoutProps: {
					title: 'IF Pay Nasıl Kullanılır?',
				},
				head: {
					title: 'IF Pay Nasıl Kullanılır?',
				},
				component: loadable(() => import('/views/pages/mabel-matiz/if-pay-usage')),
				menuIcon: 'wallet',
			},
			faq: {
				path: '/mabel-matiz/sss',
				exact: true,
				layout: 'guide',
				layoutClass: 'mabel-matiz-faq',
				layoutProps: {
					title: 'Sıkça Sorulan Sorular',
				},
				head: {
					title: 'Sıkça Sorulan Sorular',
				},
				component: loadable(() => import('/views/pages/mabel-matiz/faq')),
				menuIcon: 'help',
			},
			menu: {
				path: '/mabel-matiz/yiyecek-icecek-menu',
				exact: true,
				layout: 'guide',
				layoutClass: 'mabel-matiz-menu',
				layoutProps: {
					title: 'Yiyecek İçecek Menüsü',
				},
				head: {
					title: 'Yiyecek İçecek Menüsü',
				},
				component: loadable(() => import('/views/pages/mabel-matiz/menu')),
				menuIcon: 'qr',
			},
		},
	},
	oktoberFest: {
		path: '/oktoberfest',
		redirect: {
			key: 'oktoberFest.ifPayUsage',
			params: {},
		},
		head: {
			title: 'Oktoberfest',
		},
		children: {
			ifPayUsage: {
				path: '/oktoberfest/if-pay-nasil-kullanilir',
				exact: true,
				layout: 'guide',
				layoutClass: 'oktoberfest-if-pay-usage',
				layoutProps: {
					title: 'Oktoberfest Alışveriş Sistemi Nasıl Kullanılır?',
				},
				head: {
					title: 'IF Pay Nasıl Kullanılır?',
				},
				component: loadable(() => import('/views/pages/oktoberfest/if-pay-usage')),
				menuIcon: 'wallet',
			},
			about: {
				path: '/oktoberfest/hakkinda',
				exact: true,
				layout: 'guide',
				layoutClass: 'oktoberfest-info',
				layoutProps: {
					title: 'Oktoberfest Hakkında & Kurallar',
				},
				head: {
					title: 'Oktobefest Hakkında & Kurallar',
				},
				component: loadable(() => import('/views/pages/oktoberfest/about')),
				menuIcon: 'info',
			},
			map: {
				path: '/oktoberfest/alan-krokisi',
				exact: true,
				layout: 'guide',
				layoutClass: 'oktoberfest-map',
				layoutProps: {
					title: 'Alan Krokisi',
				},
				head: {
					title: 'Oktoberfest Alan Krokisi',
				},
				component: loadable(() => import('/views/pages/oktoberfest/map')),
				menuIcon: 'map',
			},
			lineUp: {
				path: '/oktoberfest/line-up',
				exact: true,
				layout: 'guide',
				layoutClass: 'oktoberfest-lineup',
				layoutProps: {
					title: 'Line Up',
				},
				head: {
					title: 'Oktoberfest Etkinlik Programı',
				},
				component: loadable(() => import('/views/pages/oktoberfest/line-up')),
				menuIcon: 'mic',
			},
			faq: {
				path: '/oktoberfest/sss',
				exact: true,
				layout: 'guide',
				layoutClass: 'oktoberfest-faq',
				layoutProps: {
					title: 'Sıkça Sorulan Sorular',
				},
				head: {
					title: 'Sıkça Sorulan Sorular',
				},
				component: loadable(() => import('/views/pages/oktoberfest/faq')),
				menuIcon: 'help',
			},
			menu: {
				path: '/oktoberfest/yiyecek-icecek-menu',
				exact: true,
				layout: 'guide',
				layoutClass: 'oktoberfest-menu',
				layoutProps: {
					title: 'Yiyecek İçecek Menüsü',
				},
				head: {
					title: 'Yiyecek İçecek Menüsü',
				},
				component: loadable(() => import('/views/pages/oktoberfest/menu')),
				menuIcon: 'qr',
			},
		},
	},
	party90s: {
		path: '/90-lar-partisi',
		redirect: {
			key: 'party90s.about',
			params: {},
		},
		head: {
			title: "90'lar Partisi",
		},
		children: {
			about: {
				path: '/90-lar-partisi/hakkinda',
				exact: true,
				layout: 'guide',
				layoutClass: 'p90s-about',
				layoutProps: {
					title: "90'lar Partisi Hakkında",
				},
				head: {
					title: "90'lar Partisi Hakkında",
				},
				component: loadable(() => import('/views/pages/90s/about')),
				menuIcon: 'info',
			},
			programme: {
				path: '/90-lar-partisi/etkinlik-programi',
				exact: true,
				layout: 'guide',
				layoutClass: 'p90s-programme',
				layoutProps: {
					title: "90'lar Partisi Etkinlik Programı",
				},
				head: {
					title: "90'lar Partisi Etkinlik Programı",
				},
				component: loadable(() => import('/views/pages/90s/programme')),
				menuIcon: 'mic',
			},
		},
	},
	amateurBandFormOldRedirect: {
		path: '/amator-grup-basvuru-formu',
		exact: true,
		redirect: {
			key: 'amateurBandForm',
			params: {},
		},
	},
	amateurBandForm: {
		path: '/sahne-senin',
		exact: true,
		layout: 'base',
		layoutClass: 'amateur-band-form',
		component: loadable(() => import('/views/pages/amateur-band-form')),
	},
	account: coreTicketportalRoutes.account,
	locationSelection: coreTicketportalRoutes.locationSelection,
	notFound: coreTicketportalRoutes.notFound,
	error: coreTicketportalRoutes.error,
};
